var FcConfirmCloseDialogModule = /** @class */ (function () {
    function FcConfirmCloseDialogModule() {
    }
    return FcConfirmCloseDialogModule;
}());
export { FcConfirmCloseDialogModule };
